import React from 'react'
import injectSheet from 'react-jss'
import {
  ContentContainer,
  Image,
  InfoContainer,
  TextButton,
} from '../../'

const Error = (props) => {
  const {
    classes,
    resetApp,
  } = props

  return (
    <div className={classes.app}>
      <header className={`${classes.section} ${classes.topSection}`}>
        <div className={`${classes.gridContainer}`}>
          <div className={`${classes.title}`}>
            <Image
              src="static/logo.svg"
              alt="Hauskonfigurator"
            />
          </div>
        </div>
      </header>
      <section className={`${classes.section} ${classes.mainSection}`}>
        <ContentContainer small>
          <InfoContainer warning>
            <h2>Oooops</h2>
            <p>Da ist was schief gelaufen. Versuchen Sie es noch einmal...</p>
            <div className={`${classes.buttonContainer}`}>
              <TextButton
                index={0}
                handleClick={() => resetApp()}
                text="Applikation neu starten..."
                primary
              />
            </div>
          </InfoContainer>
        </ContentContainer>
      </section>
    </div>
  )
}

const styles = theme => ({
  '@global': {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: 'Helvetica, sans-serif',
    },
    '*': {
      boxSizing: 'border-box',
      outline: 'none',
    },
  },
  app: {
    backgroundColor: theme.colors.main_2,
  },
  section: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100vw',
  },
  topSection: {
    backgroundColor: theme.colors.main_2,
    position: 'fixed',
    top: 0,
    left: 0,
    padding: `0 0 ${theme.sizes.gutter / 2}px 0`,
    boxShadow: theme.shadow.initial,
    zIndex: 100,
    height: `${theme.sizes.header}px`,
  },
  gridContainer: {
    position: 'relative',
    width: '100vw',
    maxWidth: `${theme.sizes.container}px`,
  },
  title: {
    width: '100%',
    display: 'block',
    textDecoration: 'none',
    color: theme.colors.main_3,
    padding: `0 ${theme.sizes.gutter / 2}px`,
    '& > div': {
      width: '100%',
      maxWidth: '250px',
      padding: `${theme.sizes.gutter / 2}px 0`,
    },
  },
  mainSection: {
    backgroundColor: theme.colors.secondary_3a,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
})


export default injectSheet(styles)(Error)



// WEBPACK FOOTER //
// ./src/modules/core/components/error.jsx